import Manager from '../api/manager';
import CRUDActions from './CRUD';
import clubAction from './club';

class ManagerCRUDActions extends CRUDActions {
  prefix = 'manager';

  get _model() {
    return Manager;
  }

  fetchList() {
    return dispatch => dispatch(clubAction.fetchList())
      .then(() => dispatch(super.fetchList(...arguments)));
  }

}

export default new ManagerCRUDActions();



// WEBPACK FOOTER //
// ./src/actions/manager.js